module.exports = __webpack_public_path__ + "img/toggle-on.7661129e.svg";